import React, { useState } from "react";
import "../style/ControlTechniques.css";
import LeaveMessage from "./LeaveMessage";


const ControlTechniques = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      {/* Search Results Placeholder */}
      <div id="searchResults"></div>

     <LeaveMessage />

      {/* ---------------- Heading ---------------- */}
      <section>
        <div className="heading-section">
          <h2>CONTROL AND TECHNIQUES</h2>
        </div>
      </section>

      {/* ---------------- Description ---------------- */}
      <section>
        <div className="heading">
          <p>
            A-OK motors allow customers to control their window coverings and
            doors without the limitation of location nor time. Ever-changing
            while more mature technologies keep infusing energy to motorized
            devices.
          </p>
        </div>
      </section>

      {/* ---------------- Table ---------------- */}
        <section>
            <div className="table-wrapper">
                <table>
                <tbody>
                    <tr>
                    <td>
                      RF wireless (433/868)                      
                    </td>
                    <td>
                      Bluetooth wireless                   
                    </td>
                    <td>
                      Wifi wireless                        
                    </td>
                    </tr>
                    <tr>
                    <td>
                      Zigbee wireless (zigbee hub required)                       
                    </td>
                    <td>
                      485 wired control          
                    </td>
                    <td>
                      More protocols
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </section>


      {/* ---------------- Images ---------------- */}
      <section>
        <div className="technique-img">
          <img src="/technique/20221205114333_47983.jpg" alt="image1" />
          <img src="/technique/20221205114359_31126.jpg" alt="image2" />
          <img src="/technique/20221205114413_76616.jpg" alt="image3" />
          <img src="/technique/20221205114442_65146.jpg" alt="image4" />
          <img src="/technique/20221205114509_43743.jpg" alt="image5" />
          <img src="/technique/20221205114522_65891.jpg" alt="image6" />
          <img src="/technique/20221205114535_52157.jpg" alt="image7" />
          <img src="/technique/20221205114549_74298.jpg" alt="image8" />
        </div>
      </section>
    </>
  );
};

export default ControlTechniques;
